import type { User } from '../../types/comments';
import { EntityCommentThread } from './EntityCommentThread';

interface ContactCommentThreadProps {
  contactId: number;
  users?: User[];
  currentUser?: User;
  isReadOnly?: boolean;
}

/** Thin adapter over {@link EntityCommentThread} for a contact's discussion. */
export function ContactCommentThread({ contactId, ...rest }: ContactCommentThreadProps) {
  return <EntityCommentThread target={{ type: 'contact', contactId }} {...rest} />;
}
